import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SeoHead from "./SiteSeo";
import SiteLayout from "./SiteLayout";
import { CalendlyLink, SmartLink } from "./SiteHeader";

export default function NotFoundPage() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/seo/redirects/resolve?path=${encodeURIComponent(pathname)}`)
      .then((r) => r.json()).then((d) => { if (d.to) { if (/^https?:/.test(d.to)) window.location.replace(d.to); else navigate(d.to, { replace: true }); } }).catch(() => {});
  }, [pathname, navigate]);
  return (
    <SiteLayout>
      <SeoHead title="Page not found · Hello Mortgage Team" description="We threw a wish in the well. This page isn't where we thought it'd be." path={pathname} noindex />
      <section className="hero" data-testid="not-found-page">
        <div className="hero-grid wrap solution-hero-grid has-mascot">
          <div>
            <div className="eyebrow">404 · Page not found</div>
            <h1 style={{ fontSize: "clamp(2.6rem,4.8vw,4.2rem)" }}>We threw a wish in the well.<span className="solution-h1-sub">This page isn't where we thought it'd be.</span></h1>
            <p>The link's old, the page moved, or someone typed with their thumbs. Either way—here's our number.</p>
            <div className="actions"><CalendlyLink className="btn" testId="not-found-cta">So call us, maybe</CalendlyLink><SmartLink className="textlink" href="/">Back to the homepage</SmartLink></div>
            <div className="nf-links" data-testid="not-found-links">
              <SmartLink href="/rates/">Today's rates</SmartLink><SmartLink href="/mortgages/pre-approval/">Get pre-approved</SmartLink><SmartLink href="/calculators/">Calculators</SmartLink><SmartLink href="/strategy-vault/">Strategy Vault</SmartLink>
            </div>
          </div>
          <div className="solution-hero-art"><img src="/brand/mascot-call-me.png" alt="" /></div>
        </div>
      </section>
    </SiteLayout>
  );
}
